import { useEffect, useState } from 'react';
import { Container, CheckBox, Label } from './styles';

const Switcher = (props) => {
  const { id, value, onChange } = props;
  const [localValue, setLocalValue] = useState(false);
  const elementId = `checkbox-${id}`;

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleChange = (event) => {
    const newValue = event.target.checked;

    onChange(id, newValue);
    setLocalValue(newValue);
  };

  return (
    <Container>
      <CheckBox
        id={elementId}
        type="checkbox"
        checked={localValue}
        onChange={handleChange}
      />
      <Label htmlFor={elementId} />
    </Container>
  );
};

export default Switcher;
